import isEqual from 'react-fast-compare';
import { FieldValues, Path, PathValue, UseFormSetValue } from 'react-hook-form';

export type OptionalPosField<T> = { value?: T | null; hasChanged?: boolean };

export const posField = <T>(value: T | null, hasChanged = false) => {
  return { value, hasChanged };
};

export const posChangedField = <T>(value: T | null) => {
  return posField(value, true);
};

export const posFieldFromValues = <T>(value: T | null, oldValue?: T | null) => {
  const hasChanged = !isEqual(value, oldValue);
  return posField(value, hasChanged);
};

export const safeSetPosChangedField = <
  TFormValues extends FieldValues,
  TPath extends Path<TFormValues>,
>(
  setValue: UseFormSetValue<TFormValues>,
  fieldName: TPath,
  value: PathValue<TFormValues, TPath>['value']
) => {
  const wrappedValue = posChangedField(value);
  setValue(fieldName, wrappedValue as PathValue<TFormValues, TPath>);
};

export const hasChanged = <T>(
  newP: OptionalPosField<T> | null | undefined,
  oldP: OptionalPosField<T> | null | undefined
) => {
  if (oldP == null) {
    return newP?.hasChanged;
  }

  return newP?.hasChanged && !isEqual(newP.value, oldP.value);
};
